import ActivityItemDetailsStep from "./ActivityItemDetails/ActivityItemDetailsStep";
import ActivityItemPricingStep from "./ActivityItemPricing/ActivityItemPricingStep";
import MechanicalRulesStep from "./ActivityMechanicalRules/MechanicalRulesStep";
import SummaryStep from "./Summary/SummaryStep";
import { LOT_OPTIONS } from "./ActivityItemPricing/ActivityItemPricingConsts";

export const CREATE_ACTIVITY_PRICING_STEP_KEYS = {
    ACTIVITY_DETAILS: 'activityDetails',
    PRICING: 'pricing',
    RULES: 'rules',
    SUMMARY: 'summary'
};

export const CREATE_ACTIVITY_PRICING_STEP_INDEX = {
    ACTIVITY: 0,
    PRICING: 1,
    RULES: 2
};

export const CREATE_ACTIVITY_PRICING_STEP_WARNINGS = {
    PRICING_EDITING: "You're currently editing a pricing configuration. Click 'Done' to save your changes, or they will be lost.",
    RULE_EDITING: "You're currently editing a rule. Click 'Done' to save your changes, or they will be lost.",
    NO_PRICING_CONFIGURED: 'No pricing configured yet.',
    NO_RULES_CONFIGURED: 'No automation rules configured yet.',
    MISSING_FIELDS: 'There are some missing fields. Please complete them in order to save this step.',
    ACTIVITY_REQUIRED: 'Activity details must be filled'
};

export const buildCreateActivityPricingValidationData = (steps = {}) => ({
    activityDetails: steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.ACTIVITY_DETAILS] || {},
    pricing: steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.PRICING] || {},
    rules: steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.RULES] || {}
});

export const CREATE_ACTIVITY_PRICING_STEPS = [
    {
        key: 1,
        stepKey: CREATE_ACTIVITY_PRICING_STEP_KEYS.ACTIVITY_DETAILS,
        title: 'Activity',
        subtitle: 'Define the activity',
        component: () => <ActivityItemDetailsStep />,
        validate: (data) => data.activityDetails?.name && data.activityDetails.name.trim() !== '' && data.activityDetails?.activityTypeId
    },
    {
        key: 2,
        stepKey: CREATE_ACTIVITY_PRICING_STEP_KEYS.PRICING,
        title: 'Pricing',
        subtitle: 'Set up pricing',
        component: () => <ActivityItemPricingStep />,
        validate: (data) => data.pricing?.pricingItems?.length > 0 &&
            data.pricing.pricingItems.every(item =>
                (item.isDefaultClientPricing || item.clientId) &&
                item.vendorIds?.length > 0 &&
                (item.lotOption !== LOT_OPTIONS.SPECIFIC_LOTS || item.selectedLotIds?.length > 0)
            ) &&
            !data.pricing.pricingItems.some(item => item.isNew) &&
            !data.pricing.somePricingHasUnsavedEdits
    },
    {
        key: 3,
        stepKey: CREATE_ACTIVITY_PRICING_STEP_KEYS.RULES,
        title: 'Automation',
        subtitle: 'Configure mechanical rules',
        component: () => <MechanicalRulesStep />,
        validate: (data) => data.rules?.rulesList?.length > 0 && !data.rules.rulesList.some(rule => rule.isNew) && !data.rules.someRuleHasUnsavedEdits
    },
    {
        key: 4,
        stepKey: CREATE_ACTIVITY_PRICING_STEP_KEYS.SUMMARY,
        title: 'Summary',
        subtitle: 'Review and confirm',
        component: ({ onEditStep }) => <SummaryStep onEditStep={onEditStep} />,
        validate: () => true
    }
];

export const STEP_CLEANUP_CONFIG = {
  [CREATE_ACTIVITY_PRICING_STEP_KEYS.PRICING]: {
    listKey: 'pricingItems',
    editingKey: 'editingPricingKeys',
    unsavedFlag: 'somePricingHasUnsavedEdits'
  },
  [CREATE_ACTIVITY_PRICING_STEP_KEYS.RULES]: {
    listKey: 'rulesList',
    editingKey: 'editingRuleKeys',
    unsavedFlag: 'someRuleHasUnsavedEdits'
  }
};
